import { AutoComplete, Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BiLinkExternal } from 'react-icons/bi';

import { setSearch } from '../../store/action/const';
import './styles.less';

export function Header2({ photoRef, amenitiesRef, locationRef, reviewRef, overviewRef, offersRef, urls }) {

    const [showVisitButton, setShowVisitButton] = useState(false);
    const [options, setOptions] = useState([]);
    const { cities = [], countries = [] } = useSelector(st => st.consts);

    const data = [
        ...(cities.map(e => ({ value: e.name.toUpperCase(), label: e.name }))),
        ...(countries.map(e => ({ value: e.name.toUpperCase(), label: e.name })))
    ];


    let dispatch = useDispatch();
    let navigate = useNavigate();
    let location = useLocation();

    const { Search } = Input;

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", () => {
                setShowVisitButton(window.scrollY > 50)
            });
        }
    }, []);


    return (
        <div className="header2 position-fixed"
            style={{
                backgroundColor: showVisitButton ? '#fff' : 'transparent',
                boxShadow: showVisitButton ? '0px 2px 15px rgba(25, 119, 204, 0.1)' : 'none'
            }}
        >
            <div className='container'>
                <nav className='w-100 d-none d-md-flex flex-row justify-content-between'>
                    {
                        showVisitButton ?
                            <ul className="nav d-flex">
                                <li
                                    className="nav-item my-auto me-5 pointer"
                                    style={{ color: '#000', fontSize: 15, fontWeight: 500 }}
                                    onClick={() => overviewRef.current?.scrollIntoView()}
                                >
                                    Overview
                                </li>
                                <li
                                    className="nav-item my-auto me-5 pointer"
                                    style={{ color: '#000', fontSize: 15, fontWeight: 500 }}
                                    onClick={() => amenitiesRef.current?.scrollIntoView()}
                                >
                                    Amenities
                                </li>
                                <li
                                    className="nav-item my-auto me-5 pointer"
                                    style={{ color: '#000', fontSize: 15, fontWeight: 500 }}
                                    onClick={() => photoRef.current?.scrollIntoView()}
                                >
                                    Pictures
                                </li>
                                <li
                                    className="nav-item my-auto me-5 pointer"
                                    style={{ color: '#000', fontSize: 15, fontWeight: 500 }}
                                    onClick={() => reviewRef.current?.scrollIntoView()}
                                >
                                    Reviews
                                </li>
                                <li
                                    className="nav-item my-auto me-5 pointer"
                                    style={{ color: '#000', fontSize: 15, fontWeight: 500 }}
                                    onClick={() => locationRef.current?.scrollIntoView()}
                                >
                                    Location
                                </li>
                                <li
                                    className="nav-item my-auto me-5 pointer"
                                    style={{ color: '#000', fontSize: 15, fontWeight: 500 }}
                                    onClick={() => offersRef.current?.scrollIntoView()}
                                >
                                    Offers
                                </li>
                            </ul>
                            :
                            <div className='logo d-flex align-items-center justify-content-center'>
                                <Link to='/' className='text-decoration-none'>
                                    <img src='/img/home/logo-without-bg.png' alt='Hoffero' />
                                </Link>
                            </div>
                    }

                    {
                        showVisitButton
                            ?

                            <a href={Array.isArray(urls) && urls.length ? urls[0].url : '#'} target='_blank' rel='noreferrer noopener' className='ms-auto'>
                                <Button
                                    htmlType='button'
                                    size='large'
                                    type='primary'
                                    icon={<BiLinkExternal className='me-2' />}
                                    style={{
                                        backgroundColor: '#000',
                                        color: '#fff',
                                        borderRadius: '8px',
                                        border: 'none',
                                    }}
                                >
                                    Visit Website
                                </Button>
                            </a>
                            :
                            <AutoComplete
                                dropdownMatchSelectWidth={252}
                                options={options}
                                onSelect={(val) => {
                                    dispatch(setSearch(val));
                                    navigate('/hotels');
                                }}
                                onSearch={(val) => {
                                    setOptions(() => {
                                        let str = val.toUpperCase();
                                        let filtered_options = data
                                            .filter(e => e.value.indexOf(str) !== -1)
                                            .map(e => ({ label: e.label, value: e.label }));
                                        return filtered_options;
                                    })
                                }}
                            >
                                <Search
                                    placeholder="Enter a destination or hotel" allowClear
                                    enterButton="Search" className='header-search mt-3 mt-lg-0'
                                    style={{ maxWidth: 400, width: "100%" }}
                                    onSearch={(val) => {
                                        dispatch(setSearch(val));
                                        if (!['/hotels'].includes(location.pathname)) {
                                            navigate('/hotels');
                                        }
                                    }}
                                />
                            </AutoComplete>
                    }

                </nav>
                <nav
                    className={`w-100 d-flex d-md-none ${showVisitButton ? 'flex-row justify-content-between align-items-end' : 'flex-column align-items-center justify-content-center'}`}
                >
                    <div className='logo d-flex align-items-center justify-content-center'>
                        <Link to='/' className='text-decoration-none'>
                            <img src='/img/home/logo-without-bg.png' alt='Hoffero' />
                        </Link>
                    </div>
                    {
                        showVisitButton ?
                            <a href={Array.isArray(urls) && urls.length ? urls[0].url : '#'} target='_blank' rel='noreferrer noopener' className='ms-auto'>
                                <Button
                                    htmlType='button'
                                    size='large'
                                    type='primary'
                                    icon={<BiLinkExternal className='me-2' />}
                                    style={{
                                        backgroundColor: '#000',
                                        color: '#fff',
                                        borderRadius: '8px',
                                        border: 'none',
                                    }}
                                >
                                    Visit Website
                                </Button>
                            </a>
                            :
                            <AutoComplete
                                dropdownMatchSelectWidth={252}
                                options={options}
                                onSelect={(val) => {
                                    dispatch(setSearch(val));
                                    navigate('/hotels');
                                }}
                                onSearch={(val) => {
                                    setOptions(() => {
                                        let str = val.toUpperCase();
                                        let filtered_options = data
                                            .filter(e => e.value.indexOf(str) !== -1)
                                            .map(e => ({ label: e.label, value: e.label }));
                                        return filtered_options;
                                    })
                                }}
                            >
                                <Search
                                    placeholder="Enter a destination or hotel" allowClear
                                    enterButton="Search" className='header-search mt-3 mt-lg-0'
                                    style={{ width: "100%" }}
                                    onSearch={(val) => {
                                        dispatch(setSearch(val));
                                        if (!['/hotels'].includes(location.pathname)) {
                                            navigate('/hotels');
                                        }
                                    }}
                                />
                            </AutoComplete>
                    }
                </nav>
            </div>
        </div>
    )
}